import { useEffect, useState } from "react";
import _ from "lodash";
import update from "immutability-helper";
import api from "./api";

export default function useProjects() {
  const [busy, setBusy] = useState(true);
  // issue #5
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    api("/api/projects/list")
      .then((rsp) => {
        setProjects(rsp);
        setBusy(false);
      })
      .catch((err) => setBusy(false));
  }, []);
  const add = (project) => {
    api("/api/projects/add", project).then((rsp) => {
      project.id = rsp.insertId;
      setProjects([...projects, project]);
    });
  };
  const updateProject = (project) => {
    api("/api/projects/update", project).then(() => {
      const idx = _.findIndex(projects, ["id", project.id]);
      const updatePath = _.set({}, idx + ".$set", project);
      setProjects(update(projects, updatePath));
    });
  };
  return {
    busy,
    projects,
    add,
    update: updateProject,
  };
}
